import { ErrorHandler, Injectable } from '@angular/core';

/** Presents an unhandled error message to a user. */
@Injectable({
	providedIn: 'root',
})
export class ErrorNotifier implements ErrorHandler {

	/** @inheritdoc */
	public handleError(error: unknown): void {
		// TODO (Romanov): Remove this code after we finished develop stage.
		// eslint-disable-next-line no-console
		console.log(error);
	}
}
